
















































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import Customer from "@/store/entities/customers/customer";
import Client from "../../../store/entities/client";
import opsColumns from "./ops-sale-order-request-columns";
import _ from "lodash";
import moment from "moment";

class PageSaleOrderRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  statusCode: string = AppConsts.allItemValue;
  warehouseCode: string;
  fromDate: Date;
  toDate: Date;
  customerId: number;
  salesmanId: number;
  statusCodes: any;
  productKeyword: string;
}

@Component
export default class SaleOrderRequest extends mixins(ListMixin, AbpBase) {
  allValue = AppConsts.allItemValue;
  namespace = "saleOrderRequest";
  pagerequest: PageSaleOrderRequest = new PageSaleOrderRequest();
  spinShow: boolean = false;
  creationTime: Date[] = [];
  customerLoading: boolean = false;
  customers: Array<Customer> = new Array<Customer>();
  clients: Array<Client> = new Array<Client>();
  warehouses = [];
  outboundModes = [];
  salesmanLoading: boolean = false;
  salesmans: Array<any> = new Array<any>();
  statuses = _.get(Util.abp["custom"], ["wms.SoRequest", "StatusCode"], []);
  statusPrefix = AppConsts.tableRef.tableSOR.prefix.status;
  get store() {
    return this.$store.state.saleOrderRequest;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        if (!this.isTenant())
          this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  importSaleOrderRequests() {
    this.$router.push({ path: "import-salesOrder-request" });
  }
  viewSoRequest(id: string) {
    this.$root.$router.push({
      name: `${this.namespace}/:id`,
      params: { id: id },
    });
  }

  createSoRequest() {
    this.$root.$router.push({ path: "create/sales-order-request" });
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;
    this.pagerequest.statusCodes = [];
    if (
      !_.isNil(this.pagerequest.statusCode) &&
      this.pagerequest.statusCode !== AppConsts.allItemValue
    ) {
      this.pagerequest.statusCodes = [this.pagerequest.statusCode];
    }
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (this.pagerequest.warehouseCode === AppConsts.allItemValue) {
      this.pagerequest.warehouseCode = null;
    }
    if (this.pagerequest.clientCode === AppConsts.allItemValue) {
      this.pagerequest.clientCode = null;
    }
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  renderColumn() {
    if (this.isTenant()) {
      return opsColumns;
    }
    return [];
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      {
        title: Util.L("Client"),
        width: 120,
        render: (h: any, params: any) => {
          return h("span", `${params.row.client.shortName} `);
        },
      },
      {
        title: Util.L("SoRequestCode"),
        key: "code",
        width: 150,
      },
      {
        title: Util.L("ExternalCode"),
        key: "externalCode",
        width: 150,
      },
      {
        title: Util.L("AOGroupCode"),
        key: "aoGroupCode",
        width: 150,
      },
      {
        title: Util.L("Status"),
        key: "statusCode",
        width: 120,
        render: (h: any, params: any) => {
          return h(
            "span",
            Util.L(`${this.statusPrefix}${params.row.statusCode}`)
          );
        },
      },
      ...this.renderColumn(),
      {
        title: Util.L("CustomerName"),
        key: "customerCode",
        width: 120,
        render: (h: any, params: any) => {
          if (
            _.isNil(params.row.customerCode) ||
            _.isNil(params.row.customerName)
          )
            return "";
          return h(
            "span",
            `${params.row.customerCode} - ${params.row.customerName}`
          );
        },
      },
      {
        title: Util.L("CreationTime"),
        key: "creationTime",
        width: 200,
        render: (h: any, params: any) => {
          return h("span", Util.toViewDateString(params.row.creationTime));
        },
      },
      {
        title: Util.L("Action"),
        width: 120,
        fixed: "right",
        slot: "action",
        align: "center",
      },
    ];
  }
  async created() {
    this.refreshListData();
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getWarehouses();
      var defaultDate = new Date();
      var defaultDateFrom = moment()
        .add(-7, "d")
        .toDate();
      this.creationTime = [defaultDateFrom, defaultDate];
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        if (!this.isClient())
          this.pagerequest.clientCode =
            this.clients.length === 0 ? "" : this.clients[0].code;
      });
  }

  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }
  searchSalesman_OnPress = _.debounce(
    this.searchSalesmans,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchSalesmans(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.salesmanLoading = true;
    this.salesmans = await this.$store.dispatch({
      type: "user/searchForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.salesmanLoading = false;
  }
  onChangeClient() {
    this.customers = [];
  }
  canRecheckAllPreOrders() {
    return this.hasPermission(AppConsts.permissionNames.recheckAllPreOrders);
  }
  async recheckAllPreOrders() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.RecheckAllPreOrders"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.preGetPage();
        await this.$store
          .dispatch({
            type: "saleOrderRequest/recheckAll",
            data: this.pagerequest,
          })
          .then(() => {
            this.searchData();
            Util.showSuccessMsg(this, "Success.RecheckAllPreOrders");
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
}
